import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from "@angular/router";
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app';
import { RegistrationService } from 'src/app/services/registration.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  constructor(private afAuth: AngularFireAuth, private router: Router, private registrationService: RegistrationService) { }
  user: any;
  isAdmin: any;
  ngOnInit(): void {
    this.checkIsAdmin();
  }

  login() {
    this.afAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  logout() {
    this.afAuth.signOut();
  }

  // check admin access
  checkIsAdmin (){
    this.afAuth.authState.subscribe(user => {
      this.user = user;
      this.isAdmin = this.registrationService.getEmailsAdmin().includes(user?.email);
      if ((this.router.url.includes("/danh-sach-dang-ky-kiem-hoa")  || this.router.url.includes("/danh-sach-cbcc")  || this.router.url === "/") && !this.isAdmin) {
        this.router.navigateByUrl("/dang-ky-kiem-hoa");
      }
    })
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.checkIsAdmin();
  }
}
